import { IInventoryBatchCreateProps } from "@/api_framework/api_modals/Inventory";
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from "@/constants";
import SimpleCheckbox from "@/app/components/ui/CheckBoxes/SimpleCheckbox";
import Input from "@/app/components/ui/Inputs/Input/index";
import { useInventoryBatchCreateAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryBatchCreateAPI";
import useFormValidations from "@/app/hooks/useFormValidations";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";

export interface IInventoryBatchFormFields {
  name: string;
  lotNumber: boolean;
  mrp: boolean;
  expiryDate: boolean;
  manufacturingDate: boolean;
}

const BatchAddComponent = () => {
  const navigate = useNavigate();
  const { forAllAcceptWithOutStartWithDotAndSpace } = useFormValidations();
  const { execute: createBatchAPI } = useInventoryBatchCreateAPI();

  const formHook = useForm<IInventoryBatchFormFields>({
    mode: "onChange",
    defaultValues: {
      lotNumber: true,
    },
  });

  const validateConditionalFormFields = (data: IInventoryBatchFormFields) => {
    let isValid = false;
    if (data?.name !== "") {
      isValid = true;
    }
    return isValid;
  };

  const onSubmit = (data: IInventoryBatchFormFields) => {
    const isFormSubmissionValid = validateConditionalFormFields(data);
    if (!isFormSubmissionValid) {
      return;
    }
    if (data && isFormSubmissionValid) {
      const constructedBody: IInventoryBatchCreateProps = {
        batch_group_name: data?.name,
        batching_attributes: {
          expiry_date: data?.expiryDate ? true : false,
          manufacturing_date: data?.manufacturingDate ? true : false,
          mrp: data?.mrp ? true : false,
          lot_number: data?.lotNumber ? true : false,
        },
      };
      createBatchAPI(constructedBody).then(({ status }) => {
        if (status) {
          navigate(`/app/inventory/batch`);
        }
      });
    }
  };

  const handelBackToTaxList = () => {
    navigate(`/app/inventory/batch`);
  };

  return (
    <div className="p-4 rounded-md bg-white px-4 py-3">
      <form className=" w-full mt-2" onSubmit={formHook.handleSubmit(onSubmit)}>
        <h2 className="text-base font-semibold">Batching Setup</h2>
        <div className="mt-8 flex flex-col gap-6 pb-24">
          <div className="flex flex-col gap-1.5 sm:flex-row sm:items-center sm:gap-0">
            <div className="w-full shrink-0 text-sm sm:text-base sm:w-[130px]">
              <p>
                Name <span className="text-red-400">*</span>
              </p>
            </div>
            <div className="w-full sm:w-3/6 lg:w-1/4">
              <Input
                className="text-xs"
                inputClassName="h-[38px] rounded-lg"
                placeholder="Enter Batch Name"
                register={formHook.register("name", {
                  required: true,
                  ...forAllAcceptWithOutStartWithDotAndSpace.validations,
                })}
                fieldError={formHook.formState.errors.name}
                errorMessages={[
                  { message: "Name is required", type: "required" },
                  forAllAcceptWithOutStartWithDotAndSpace.errors,
                ]}
              />
            </div>
          </div>
          <div>
            <p className="text-sm font-semibold mt-2">
              Select Batching Attributes <span className="text-red-400">*</span>
            </p>
            <div className="flex flex-wrap gap-x-6 gap-y-3 mt-4">
              <SimpleCheckbox
                onChange={() => {
                  if (formHook.watch("lotNumber")) {
                    formHook.setValue("lotNumber", false);
                  } else {
                    formHook.setValue("lotNumber", true);
                  }
                }}
                checked={formHook.watch("lotNumber")}
                id="LOTNumber"
                colorClassName="text-[#202223] cursor-pointer"
                descriptionContent={
                  <label htmlFor="LOTNumber" className="ml-3 block text-xs leading-6 font-medium text-gray-700">
                    Lot Number
                  </label>
                }
              />
              <SimpleCheckbox
                onChange={() => {
                  if (formHook.watch("mrp")) {
                    formHook.setValue("mrp", false);
                  } else {
                    formHook.setValue("mrp", true);
                  }
                }}
                checked={formHook.watch("mrp")}
                id="MRP"
                colorClassName="text-[#202223] cursor-pointer"
                descriptionContent={
                  <label htmlFor="MRP" className="ml-3 block text-xs leading-6 font-medium text-gray-700">
                    MRP
                  </label>
                }
              />
              <SimpleCheckbox
                onChange={() => {
                  if (formHook.watch("expiryDate")) {
                    formHook.setValue("expiryDate", false);
                  } else {
                    formHook.setValue("expiryDate", true);
                  }
                }}
                checked={formHook.watch("expiryDate")}
                id="expiry"
                colorClassName="text-[#202223] cursor-pointer"
                descriptionContent={
                  <label htmlFor="expiry" className="ml-3 block text-xs font-medium leading-6 text-gray-700">
                    Expiry Date
                  </label>
                }
              />
              <SimpleCheckbox
                onChange={() => {
                  if (formHook.watch("manufacturingDate")) {
                    formHook.setValue("manufacturingDate", false);
                  } else {
                    formHook.setValue("manufacturingDate", true);
                  }
                }}
                checked={formHook.watch("manufacturingDate")}
                id="Manufacturing"
                colorClassName="text-[#202223] cursor-pointer"
                descriptionContent={
                  <label htmlFor="Manufacturing" className="ml-3 block text-xs font-medium leading-6 text-gray-700">
                    Manufacturing Date
                  </label>
                }
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end p-4 gap-4 items-center right-0 bottom-0 w-full fixed bg-white border-t-2">
          <button type="button" className={SECONDARY_BUTTON} onClick={() => handelBackToTaxList()}>
            Cancel
          </button>
          <button type="submit" className={PRIMARY_BUTTON}>
            Save
          </button>
        </div>
      </form>
    </div>
  );
};
export default BatchAddComponent;
